<div class="edit-dialog-container">
  <div class="dialog-header">
    <p><strong>Edit Collection Privacy</strong></p>
    <button class="close-dialog" mat-icon-button (click)="dialogRef.close()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="name-input-container">
    <div class="privacy-toggle-container">
      <mat-slide-toggle [checked]="isPrivate" (change)="togglePrivacy()" color="primary"> Private </mat-slide-toggle>
      <mat-chip-set>
        <mat-chip>{{ isPrivate ? 'Private' : 'Public' }}</mat-chip>
        <mat-chip *ngIf="isOwner"> Owner </mat-chip>
      </mat-chip-set>
    </div>
    <p>Only you and users in the access list can view this collection.</p>

    <mat-form-field *ngIf="isPrivate" appearance="outline" color="accent" class="access-list">
      <mat-label>Access List</mat-label>
      <mat-chip-grid #chipGrid aria-label="Access List">
        <mat-chip-row *ngFor="let user_id of accessList.value" [removable]="true" (removed)="removeAccess(user_id)">
          {{ getEmail(user_id) }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <input
          #chipInput
          placeholder="Search for users..."
          [matChipInputFor]="chipGrid"
          [formControl]="searchControl"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matAutocomplete]="auto"
          (matChipInputTokenEnd)="addAccessFromInput($event)" />
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addAccess($event)" [displayWith]="displayUser">
        <mat-option *ngFor="let user of filteredUsers$ | async" [value]="user">
          {{ user.email }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="button-container">
    <button (click)="saveForm()" mat-flat-button color="primary">Save Changes</button>
  </div>
</div>
